<template>
    <div class="privacy-policy-wrapper">
        <!-- Header -->
        <header class="policy-header">
            <div class="header-inner">
                <b-button variant="link" class="back-btn" :to="{ name: 'login' }">
                    <feather-icon icon="ArrowLeftIcon" size="16" />
                    <span>Geri Dön</span>
                </b-button>
                <div class="header-logo">
                    <b-img src="@/assets/images/logo/hnz-long-logo.png" alt="HNZ Kozmetik" height="36" @error="logoError = true" v-if="!logoError" />
                    <span v-else class="logo-text">HNZ Kozmetik</span>
                </div>
            </div>
        </header>

        <!-- Main Content -->
        <main class="policy-content">
            <div class="content-inner">
                <!-- Başlık -->
                <div class="policy-header-section">
                    <h1 class="policy-title">Gizlilik ve Kişisel Verilerin Korunması</h1>
                    <p class="policy-subtitle">portal.hnzkozmetik.com kullanım koşulları</p>
                </div>

                <!-- Uyarı -->
                <div class="notice-banner">
                    <feather-icon icon="InfoIcon" size="16" />
                    <span>Portal'ı kullanarak işbu Gizlilik Taahhüdü'nü kabul etmiş sayılırsınız.</span>
                </div>

                <!-- İçerik Kartı -->
                <div class="policy-card">
                    <!-- Giriş -->
                    <p class="intro-text">Bu Gizlilik Taahhüdü, portal.hnzkozmetik.com üzerinden sunulan ödeme ve tahsilat hizmetleri kapsamında, kişisel verilerinizin işlenme süreçlerini açıklamaktadır.</p>

                    <!-- Madde 1 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">01</span>
                            <h2>Veri Sorumlusu</h2>
                        </div>
                        <div class="section-body">
                            <p>
                                6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca kişisel verileriniz;
                                <strong class="highlight">HNZ Kozmetik</strong> tarafından, veri sorumlusu sıfatıyla işlenmektedir.
                            </p>
                        </div>
                    </section>

                    <!-- Madde 2 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">02</span>
                            <h2>İşlenen Kişisel Veriler</h2>
                        </div>
                        <div class="section-body">
                            <p>Ödeme ve tahsilat işlemleri kapsamında:</p>
                            <ul class="policy-list cols-2">
                                <li v-for="(item, index) in processedData" :key="index">
                                    <feather-icon icon="CheckIcon" size="14" />
                                    <span>{{ item }}</span>
                                </li>
                            </ul>
                            <div class="info-note">
                                <feather-icon icon="AlertCircleIcon" size="14" />
                                <span>Kredi kartı bilgileri portal tarafından saklanmaz. Ödemeler yetkili altyapılar üzerinden gerçekleştirilir.</span>
                            </div>
                        </div>
                    </section>

                    <!-- Madde 3 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">03</span>
                            <h2>Veri İşleme Amaçları</h2>
                        </div>
                        <div class="section-body">
                            <ul class="policy-list">
                                <li v-for="(purpose, index) in purposes" :key="index">
                                    <feather-icon icon="ChevronRightIcon" size="14" />
                                    <span>{{ purpose }}</span>
                                </li>
                            </ul>
                        </div>
                    </section>

                    <!-- Madde 4 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">04</span>
                            <h2>Veri Aktarımı</h2>
                        </div>
                        <div class="section-body">
                            <p>Kişisel verileriniz yalnızca şu kurumlarla paylaşılır:</p>
                            <ul class="policy-list cols-2">
                                <li v-for="(org, index) in transferOrgs" :key="index">
                                    <feather-icon icon="BuildingIcon" size="14" />
                                    <span>{{ org }}</span>
                                </li>
                            </ul>
                            <div class="warning-note">
                                <feather-icon icon="ShieldIcon" size="14" />
                                <span>Kişisel verileriniz ticari amaçlarla üçüncü kişilere satılmaz veya pazarlama amacıyla paylaşılmaz.</span>
                            </div>
                        </div>
                    </section>

                    <!-- Madde 5 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">05</span>
                            <h2>Toplama Yöntemi ve Hukuki Sebep</h2>
                        </div>
                        <div class="section-body">
                            <p>Verileriniz; formlar, ödeme linkleri ve elektronik ortamda otomatik yollarla toplanır.</p>
                            <ul class="policy-list">
                                <li>
                                    <feather-icon icon="FileTextIcon" size="14" />
                                    <span>Bir sözleşmenin kurulması veya ifası</span>
                                </li>
                                <li>
                                    <feather-icon icon="BookOpenIcon" size="14" />
                                    <span>Hukuki yükümlülüklerin yerine getirilmesi</span>
                                </li>
                                <li>
                                    <feather-icon icon="TargetIcon" size="14" />
                                    <span>Meşru menfaat</span>
                                </li>
                            </ul>
                        </div>
                    </section>

                    <!-- Madde 6 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">06</span>
                            <h2>Veri Güvenliği</h2>
                        </div>
                        <div class="section-body">
                            <ul class="policy-list cols-2">
                                <li>
                                    <feather-icon icon="LockIcon" size="14" />
                                    <span>SSL Şifreleme</span>
                                </li>
                                <li>
                                    <feather-icon icon="ServerIcon" size="14" />
                                    <span>Güvenli Sunucu</span>
                                </li>
                                <li>
                                    <feather-icon icon="KeyIcon" size="14" />
                                    <span>Erişim Kontrolü</span>
                                </li>
                                <li>
                                    <feather-icon icon="RefreshCwIcon" size="14" />
                                    <span>Güncel Yazılım</span>
                                </li>
                            </ul>
                        </div>
                    </section>

                    <!-- Madde 7 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">07</span>
                            <h2>Haklarınız</h2>
                        </div>
                        <div class="section-body">
                            <p>KVKK'nın 11. maddesi kapsamında:</p>
                            <ul class="policy-list cols-2">
                                <li v-for="(right, index) in rights" :key="index">
                                    <span class="list-num">{{ index + 1 }}</span>
                                    <span>{{ right }}</span>
                                </li>
                            </ul>
                        </div>
                    </section>

                    <!-- Madde 8 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">08</span>
                            <h2>Başvuru</h2>
                        </div>
                        <div class="section-body">
                            <p>Taleplerinizi yazılı olarak veya kayıtlı elektronik posta (KEP) aracılığıyla iletebilirsiniz. Başvurular <strong>30 gün</strong> içinde ücretsiz olarak sonuçlandırılır.</p>
                        </div>
                    </section>

                    <!-- Madde 9 -->
                    <section class="policy-section">
                        <div class="section-header">
                            <span class="section-num">09</span>
                            <h2>Değişiklikler</h2>
                        </div>
                        <div class="section-body">
                            <p>Bu taahhüdü mevzuat değişikliklerine göre güncelleyebiliriz. Güncel metin her zaman portal.hnzkozmetik.com üzerinde yayımlanır.</p>
                        </div>
                    </section>

                    <!-- Madde 10 -->
                    <section class="policy-section last">
                        <div class="section-header">
                            <span class="section-num">10</span>
                            <h2>Yürürlük</h2>
                        </div>
                        <div class="section-body">
                            <p>Bu Gizlilik Taahhüdü, Portal üzerinden erişildiği anda yürürlüğe girer.</p>
                        </div>
                    </section>
                </div>
            </div>
        </main>

        <!-- Footer -->
        <footer class="policy-footer">
            <div class="footer-inner">
                <div class="footer-contact">
                    <span><feather-icon icon="PhoneIcon" size="12" /> {{ $param("company.phone") }}</span>
                    <span><feather-icon icon="MapPinIcon" size="12" /> {{ $param("company.address") }}</span>
                </div>
                <div class="footer-copyright">© {{ new Date().getFullYear() }} Sedbim - Tüm hakları saklıdır.</div>
            </div>
        </footer>
    </div>
</template>

<script>
import { BButton, BImg } from "bootstrap-vue";

export default {
    name: "PrivacyPolicy",
    components: {
        BButton,
        BImg,
    },
    data() {
        return {
            logoError: false,
            processedData: ["Ad, soyad", "Telefon numarası", "E-posta adresi", "Ödeme tutarı", "Fatura bilgileri", "IP adresi", "Cihaz bilgileri", "İşlem tarihi/saati"],
            purposes: ["Ödeme ve tahsilat süreçlerinin yürütülmesi", "Finansal işlemlerin kayıt altına alınması", "Muhasebe ve yasal yükümlülüklerin yerine getirilmesi", "Müşteri iletişiminin sağlanması", "Olası uyuşmazlıkların çözümü", "Bilgi güvenliği ve sistem güvenliğinin sağlanması"],
            transferOrgs: ["Bankalar", "Ödeme Kuruluşları", "Mali Müşavirlik", "Yetkili Kamu Kurumları"],
            rights: ["İşlenip işlenmediğini öğrenme", "Bilgi talep etme", "Amaç ve yöntemi öğrenme", "Aktarılanları bilme", "Düzeltilmesini isteme", "Silinmesini isteme", "Aktarılanlara bildirilmesini isteme", "Otomatik analize itiraz etme", "Zararın giderilmesini isteme"],
        };
    },
    metaInfo: {
        title: "Gizlilik Politikası - HNZ Kozmetik",
    },
};
</script>

<style lang="scss" scoped>
// Variables
$primary: #08a1ae;
$text-dark: #1a202c;
$text-muted: #64748b;
$border-color: #e2e8f0;
$bg-light: #f8fafc;
$bg-page: #f1f5f9;

// Reset & Base
.privacy-policy-wrapper {
    background: $bg-page;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

// Header
.policy-header {
    background: #fff;
    border-bottom: 1px solid $border-color;
    position: sticky;
    top: 0;
    z-index: 100;

    .header-inner {
        max-width: 900px;
        margin: 0 auto;
        padding: 0.75rem 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .back-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.375rem;
        color: $text-muted;
        font-size: 0.875rem;
        font-weight: 500;
        padding: 0.375rem 0;
        text-decoration: none;

        &:hover {
            color: $primary;
        }
    }

    .header-logo {
        img {
            height: 36px;
            object-fit: contain;
        }
    }

    .logo-text {
        font-size: 1.125rem;
        font-weight: 700;
        color: $primary;
    }
}

// Main Content
.policy-content {
    flex: 1;
    padding: 1.5rem 1rem;

    .content-inner {
        max-width: 900px;
        margin: 0 auto;
    }
}

// Header Section
.policy-header-section {
    text-align: center;
    margin-bottom: 1rem;

    .policy-title {
        font-size: 1.5rem;
        font-weight: 700;
        color: $text-dark;
        margin: 0 0 0.25rem;
    }

    .policy-subtitle {
        font-size: 0.875rem;
        color: $text-muted;
        margin: 0;
    }
}

// Notice Banner
.notice-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: #fef3c7;
    border: 1px solid #fcd34d;
    border-radius: 6px;
    padding: 0.625rem 1rem;
    margin-bottom: 1rem;
    font-size: 0.8125rem;
    font-weight: 500;
    color: #92400e;
}

// Card
.policy-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 1.5rem;
}

// Intro
.intro-text {
    font-size: 0.9375rem;
    line-height: 1.6;
    color: $text-muted;
    margin: 0 0 1.25rem;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid $border-color;
}

// Sections
.policy-section {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid $border-color;

    &.last {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
    }

    .section-header {
        display: flex;
        align-items: center;
        gap: 0.625rem;
        margin-bottom: 0.625rem;

        .section-num {
            font-size: 0.75rem;
            font-weight: 700;
            color: $primary;
            background: rgba($primary, 0.1);
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            flex-shrink: 0;
        }

        h2 {
            font-size: 1rem;
            font-weight: 600;
            color: $text-dark;
            margin: 0;
        }
    }

    .section-body {
        padding-left: 2.375rem;

        @media (max-width: 576px) {
            padding-left: 0;
        }

        p {
            font-size: 0.875rem;
            line-height: 1.6;
            color: #475569;
            margin: 0 0 0.5rem;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .highlight {
            color: $primary;
        }
    }
}

// Unified List Style
.policy-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;

    &.cols-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.375rem 1rem;

        @media (max-width: 576px) {
            grid-template-columns: 1fr;
        }
    }

    li {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
        font-size: 0.8125rem;
        color: #475569;
        line-height: 1.5;

        svg {
            color: $primary;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .list-num {
            font-size: 0.6875rem;
            font-weight: 700;
            color: #fff;
            background: $primary;
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            flex-shrink: 0;
            margin-top: 1px;
        }
    }
}

// Notes
.info-note,
.warning-note {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    font-size: 0.8125rem;
    line-height: 1.5;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    margin-top: 0.625rem;

    svg {
        flex-shrink: 0;
        margin-top: 2px;
    }
}

.info-note {
    background: #eff6ff;
    color: #1e40af;
    border: 1px solid #bfdbfe;

    svg {
        color: #3b82f6;
    }
}

.warning-note {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;

    svg {
        color: #dc2626;
    }
}

// Footer
.policy-footer {
    background: #fff;
    border-top: 1px solid $border-color;
    margin-top: auto;

    .footer-inner {
        max-width: 900px;
        margin: 0 auto;
        padding: 0.75rem 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.5rem;

        @media (max-width: 576px) {
            flex-direction: column;
            text-align: center;
        }
    }

    .footer-contact {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-size: 0.75rem;
        color: $text-muted;

        span {
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
        }

        @media (max-width: 576px) {
            flex-direction: column;
            gap: 0.25rem;
        }
    }

    .footer-copyright {
        font-size: 0.75rem;
        color: $text-muted;
    }
}
</style>
